import { render, staticRenderFns } from "./MyManage.vue?vue&type=template&id=48e4afe7&scoped=true&"
import script from "./MyManage.vue?vue&type=script&lang=js&"
export * from "./MyManage.vue?vue&type=script&lang=js&"
import style0 from "./MyManage.vue?vue&type=style&index=0&id=48e4afe7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e4afe7",
  null
  
)

export default component.exports